import React, { useState, useEffect } from "react";
import { FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";

import "../css-coding/CScontent1.css";

import ContinueReading from "./ContinueReading";

import art1cs1 from '../assets/CS1.png';


const CScontent1 = () => {

    const contentData = [
    { title: "Saree Styling Hacks", views: "1.3 Million Views", impact: "Trending beauty tutorial" },
    { title: "Power of Bindi", views: "2.9 Million Views", impact: "Most viral video" },
    { title: "Lipshades for Indian Skin Tone", views: "2.6 Million Views", impact: "High engagement beauty guide" },
    { title: "5 Tricks for Kajal Lovers", views: "1.2 Million Views", impact: "Popular makeup tutorial" },
    { title: "Eyebrows for Different Face Shapes", views: "279K Views", impact: "Educational beauty content" },
    { title: "Finding Sunscreen Made Easy", views: "222K Views", impact: "Skincare educational content" },
    { title: "5 Wedding Color Combo", views: "171K Views", impact: "Bridal makeup inspiration" },
  ];

  return (
    <div className="article-container-1-cas">

      <div className="article-wrapper-cas">

        {/* Main Content */}
        <div className="article-content-1-cas">
          <h1 className="top-zero-cas">
            How We Helped Rajees Makeover Gain 24,000 Organic Followers in Just 1.5 Months
          </h1>
          
          <p className="article-date-1-cas" style={{ marginRight: '10px' }}> 📈 Case Sudy</p>
          <img className="article-image-main-cas" src={art1cs1} alt="Personal Branding" />
    
          <div className="article-body-cas">
            <div className="social-icons-sticky-cas">
              <a href="https://www.instagram.com/thegrowthsecretmedia" target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>
              <a href="https://www.youtube.com/@thegrowthsecretmedia" target="_blank" rel="noreferrer">
                <FaYoutube />
              </a>
              <a href="https://www.linkedin.com/company/thegrowthsecretmedia/" target="_blank" rel="noreferrer">
                <FaLinkedinIn />
              </a>
            </div>
   
            <div className="left-txt-cas">
              <h1>Client Overview (Rajees Makeover)</h1>

             <p><b>Industry:</b> Beauty & Makeup Services</p>
                <p><b>Location:</b> Tamil Nadu, India</p>
                <p><b>Specialization:</b> Makeup Artist & Bridal Makeover Expert</p>
                <p><b>Services:</b> Professional makeup, bridal transformations across Tamil Nadu</p>
                <p> <b>Challenge:</b> Low social media engagement and limited lead generation</p>
              
              
             

              <h1>The Challenge: From Stagnant Growth to Social Media Success</h1>

              <p>
              When Rajees Makeover approached The Growth Secret, they were facing
common challenges that many beauty professionals encounter in today's
digital landscape:
              </p>

                <ul className="checklist-3-cas">
                <li><b>Limited Reach:</b> Stuck at 800 followers with minimal organic growth</li>
                <li><b>Low Engagement:</b> Videos averaging only 4,000-5,000 views</li>
                <li><b>Lead Generation Issues: </b> Struggling to convert social media presence
into paying clients</li>
                <li><b>Content Strategy Gap: </b>  Lack of strategic content planning and
professional execution</li>
              </ul>

           

              <p>
              As a talented makeup artist serving clients across Tamil Nadu, Rajees had the
skills but needed expert digital marketing support to showcase her expertise
and attract her ideal clientele.
              </p>

            

              <h1>Our Strategic Approach: Complete Content
Transformation</h1>
              <p>
                At The Growth Secret Media, we implemented our proven 360-degree content
strategy, focusing on three core pillars:
              </p>

              <h2>1. Script Ideation & Content Strategy</h2>
              <ul className="checklist-4-cas">
                <li> Developed viral-worthy script concepts tailored to beauty enthusiasts</li>
                <li> Created content themes around makeup tutorials, beauty hacks, and
bridal tips</li>
                <li> Focused on trending topics that resonate with Tamil Nadu's beauty
community</li>
              </ul>

              <h2>2. Professional Video Editing</h2>

              <ul className="checklist-4-cas">
                <li> Applied our signature editing style with engaging transitions and eﬀects</li>
                <li> Enhanced video quality with professional color grading and motion graphics </li>
                <li> Optimized content for Instagram's algorithm and user engagement</li>
              </ul>

                <h2>3. Eye-Catching Thumbnail Design</h2>

              <ul className="checklist-4-cas">
                <li> Designed compelling Instagram thumbnails that drive clicks</li>
                <li> Maintained consistent branding across all visual content </li>
                <li> Created thumbnails optimized for mobile viewing experience</li>
              </ul>

              <h1>Remarkable Results: The Numbers Speak for
Themselves</h1>
 <h2>Follower Growth Transformation</h2>
                  

                <ul className="checklist-3-cas">
                <li><b>Starting Point:</b>  800 followers </li>
                <li><b>End Result:</b> 24,000 organic followers</li>
                <li><b>Time Frame:</b> Just 1.5 months</li>
                <li><b>Content Pieces:  </b>  31 strategic posts </li>
                <li><b>Growth Rate: </b>  2,900% increase in followers </li>
              </ul>
     <h2>Viral Content Performance</h2>
     <p>Our strategic content creation delivered exceptional results:</p>
     
     <section className="table-section">
          <div className="table-scroll">
        <table className="cs1-table">
          <thead>
            <tr>
              <th>Content Title</th>
              <th>Views Achieved</th>
              <th>Impact</th>
            </tr>
          </thead>
          <tbody>
            {contentData.map((item, index) => (
              <tr key={index}>
                <td>{item.title}</td>
                <td>{item.views}</td>
                <td>{item.impact}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
     </section>

<h2>Before vs. After Performance</h2>

     <ul className="checklist-3-cas">
                <li><b>Previous Average Views: </b> 4,000-5,000 per video</li>
                <li><b>New Average Views: </b> 200K+ per video</li>
                <li><b>Peak Performance: </b> 2.9 million views on single content</li>
                <li><b>Engagement Rate: </b> Increased by 500%+
</li>
              </ul>

              <h1>Lead Generation Success</h1>
              <p>Beyond impressive follower growth, our strategy delivered tangible business
results:</p>
               
                <ul className="checklist-3-cas">
                <li><b>Qualified Leads:  </b> Significant increase in bridal makeup inquiries</li>
                <li><b>Geographic Reach: </b> Expanded client base across Tamil Nadu</li>
                <li><b>Brand Recognition: </b> Established as a leading makeup artist in the
region</li>
                <li><b>Business Growth:  </b> Substantial increase in booking requests and
revenue
</li>
              </ul>

            

             <h1>The Growth Secret Media Advantage: Why Our
Strategy Worked</h1>

           

           

              

              

              <h2>1. Deep Market Understanding</h2>
              <p>
               Our team's expertise in the Tamil Nadu market allowed us to create culturally
relevant content that resonated with the target audience.
              </p>

              <h2>2. Data-Driven Content Strategy</h2>
              <p>
                We analyzed trending topics, optimal posting times, and audience preferences
to maximize reach and engagement.
              </p>

              <h2>3. Professional Production Quality</h2>
              <p>
              Our advanced video editing techniques using Premiere Pro and After Eﬀects
ensured every piece of content met professional standards.
              </p>

              <h2>4. Consistent Brand Voice</h2>
              <p>
               We maintained Rajees Makeover's authentic voice while elevating the content
quality and strategic messaging.
              </p>

              <h2>5. Algorithm Optimization</h2>
              <p>
               Our content was specifically optimized for Instagram's algorithm, ensuring
maximum organic reach and engagement.
              </p>

              
           

             


            
            </div>
          </div>
        </div>
      </div>

     
    </div>
  );
};

export default CScontent1;
